import {
  CHANGE_SELECTED_VIEW,
  SEARCH_RESULT_DELETE_SUCCESS,
  SEARCH_RESULT_FAVORITE_SUCCESS,
  SEARCH_RESULT_UNFAVORITE_SUCCESS,
  SEARCH_RESULT_UPDATE_ATTRIBUTES,
  SEARCH_RESULT_UPDATE_REQUEST,
  SEARCH_RESULT_UPDATE_SUCCESS,
  SEARCH_RESULT_UPDATE_FAILURE,
  SEARCH_RESULTS_REQUEST,
  SEARCH_RESULTS_SUCCESS,
  SEARCH_RESULTS_FAILURE,
  TOGGLE_ALL_RESULTS,
  TOGGLE_ALL_SELECTED_RESULTS,
  TOGGLE_EXPAND_RESULT,
  TOGGLE_SELECT_RESULT
} from '../actions/searchResultActions'
import { updateObjectInCollection } from '../utils/reduxHelpers'

const initialCounts = {
  all: 0,
  projects: 0,
  files: 0,
  highlights: 0,
  playlists: 0,
  clips: 0,
  responses: 0
}

function counts(state = initialCounts, action) {
  switch (action.type) {
    case SEARCH_RESULTS_SUCCESS:
      const { counts } = action.response

      return Object.assign({}, state, {
        all: counts.all,
        projects: counts.projects,
        files: counts.projectDocuments,
        highlights: counts.highlights,
        playlists: counts.playlists,
        clips: counts.videoClips,
        responses: counts.responses
      })
    default:
      return state
  }
}

const initialState = {
  allExpanded: false,
  allSelected: false,
  counts: counts(undefined, {}),
  currentPage: 1,
  isFetching: false,
  results: [],
  selectedView: 'list',
  totalPages: 1
}

export default function searchResults(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SELECTED_VIEW:
      return Object.assign({}, state, {
        selectedView: action.view
      })
    case TOGGLE_ALL_RESULTS:
      return Object.assign({}, state, {
        allExpanded: action.expanded,
        results: state.results.map(result => {
          return Object.assign({}, result, { expanded: action.expanded })
        })
      })
    case TOGGLE_ALL_SELECTED_RESULTS:
      return Object.assign({}, state, {
        allSelected: action.selected,
        results: state.results.map(result => {
          return Object.assign({}, result, { selected: action.selected })
        })
      })
    case TOGGLE_EXPAND_RESULT:
      return Object.assign({}, state, {
        allExpanded: action.result.expanded ? false : state.allExpanded,
        results: updateObjectInCollection(state.results, action.result.id, {
          expanded: !action.result.expanded
        })
      })
    case TOGGLE_SELECT_RESULT:
      return Object.assign({}, state, {
        allSelected: action.result.selected ? false : state.allSelected,
        results: updateObjectInCollection(state.results, action.result.id, {
          selected: !action.result.selected
        })
      })
    case SEARCH_RESULT_FAVORITE_SUCCESS:
      return Object.assign({}, state, {
        results: updateObjectInCollection(state.results, action.result.id, {
          favoriteFl: true
        })
      })
    case SEARCH_RESULT_UNFAVORITE_SUCCESS:
      return Object.assign({}, state, {
        results: updateObjectInCollection(state.results, action.result.id, {
          favoriteFl: false
        })
      })
    case SEARCH_RESULTS_REQUEST:
      return Object.assign({}, state, {
        counts: counts(state.counts, action),
        currentPage: 1,
        results: [],
        isFetching: true
      })
    case SEARCH_RESULTS_SUCCESS:
      const { results, totalPages } = action.response

      return Object.assign({}, state, {
        totalPages,
        results,
        counts: counts(state.counts, action),
        allExpanded: false,
        allSelected: false,
        isFetching: false
      })
    case SEARCH_RESULT_DELETE_SUCCESS:
      let idx = state.results.indexOf(action.result)

      return Object.assign({}, state, {
        results: [
          ...state.results.slice(0, idx),
          ...state.results.slice(idx + 1)
        ]
      })
    case SEARCH_RESULT_UPDATE_ATTRIBUTES:
      return Object.assign({}, state, {
        results: updateObjectInCollection(
          state.results,
          action.result.id,
          action.attributes
        )
      })
    case SEARCH_RESULT_UPDATE_REQUEST:
      return Object.assign({}, state, {
        results: updateObjectInCollection(state.results, action.result.id, {
          saving: true
        })
      })
    case SEARCH_RESULT_UPDATE_SUCCESS:
      const values = Object.keys(action.data).map(key => action.data[key])

      return Object.assign({}, state, {
        results: updateObjectInCollection(state.results, action.result.id, {
          ...values[0],
          saving: false
        })
      })
    case SEARCH_RESULT_UPDATE_FAILURE:
      return Object.assign({}, state, {
        results: updateObjectInCollection(state.results, action.result.id, {
          saving: false
        })
      })
    case SEARCH_RESULTS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/searchResults.js